var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DepartmentContacts',{attrs:{"heading":_vm.data.heading || '',"phones":_vm.data.phones || [],"email":_vm.data.email || '',"address":_vm.data.address || '',"map-image":_vm.data.mapImage || '',"map-alt":_vm.data.mapAlt || ''}})}
var staticRenderFns = []

export { render, staticRenderFns }